export const CLIENT = '/client/v1.0';
export const IDENTITY = '/identity/v1.0';
export const EXPORT = `/export/v1.0`;
export const USER = '/user/v1.0';

// Well-known DOE funder id. Must match the backend FunderIds.Doe constant.
export const DOE_FUNDER_ID = '10000000-0000-0000-0000-000000000d0e';

export const isDoeFunder = (funderId?: string | null): boolean =>
	funderId ? funderId.toLowerCase() === DOE_FUNDER_ID : false;

// Well-known ELC day-center funder id. Must match the backend seed (WellKnownFunders.Elc).
// Used to identify actual ELC sessions (SessionType.FunderId) vs other funder-backed sessions (e.g. DOE).
export const ELC_FUNDER_ID = '10000000-0000-0000-0000-000000000e1c';

// Casing-safe ELC funder check. GUIDs can arrive in either case from the API, so always compare
// lowercased against the (lowercase) ELC_FUNDER_ID constant. This is the one place that hides the
// .toLowerCase() footgun; everything else composes on top of it.
export const isElcFunder = (funderId?: string | null): boolean =>
	funderId ? funderId.toLowerCase() === ELC_FUNDER_ID : false;

export const BILLING = `${CLIENT}/billing`;
export const CLIENT_USERS = `${CLIENT}/users`;
export const CLIENTS = `${CLIENT}/clients`;
export const SESSIONS = `${CLIENT}/sessions`;
export const TARGETS = `${CLIENT}/targets`;
export const BEHAVIORS = `${CLIENT}/behaviors`;
export const CALENDAR = `${CLIENT}/calendar`;
export const SOAP_NOTES = `${CLIENT}/soap-notes`;
export const BRANCHES = `${CLIENT}/branches`;
export const DASHBOARD = `${CLIENT}/dashboard`;
export const INSURANCE_AUTHORIZATION = `${CLIENT}/insurance-authorization`;
export const USERS = `${USER}/users`;
export const USER_SESSION_ALLOCATIONS = `${USER}/user-session-allocations`;
export const CLINICAL_SUPERVISORS = `${USERS}/clinical-supervisors`;
export const TRAINING_CERTIFICATIONS = `${CLIENT}/training-certifications`;
export const TARGETS_ANNOTATIONS = `${TARGETS}/annotations`;
export const TARGETS_GLOBAL_ANNOTATIONS = `${TARGETS}/annotations/global`;
export const BEHAVIORS_ANNOTATIONS = `${BEHAVIORS}/annotations`;
export const BEHAVIORS_GLOBAL_ANNOTATIONS = `${BEHAVIORS}/annotations/global`;
export const CALENDAR_EVENTS = `${CALENDAR}/events`;
export const DISCRETIONARY_HOURS = `${CLIENT}/discretionary-hours`;
export const AI = `${CLIENT}/ai`;

export const PROGRAMS = (skillAreaId: string) => `${CLIENT}/skill-areas/${skillAreaId}/programs`;
export const SKILL_AREA = (clientId: string) => `${CLIENTS}/${clientId}/skill-areas`;
export const PROGRAM_TARGET = (programId: string) => `${CLIENT}/programs/${programId}/targets`;
export const CLIENT_BEHAVIORS = (clientId: string) => `${CLIENTS}/${clientId}/behaviors`;
export const CLIENT_SOAP_NOTES = (clientId: string) => `${CLIENTS}/${clientId}/soap-notes`;
export const CLIENT_INSURANCE_AUTHORIZATION = (clientId: string) => `${CLIENTS}/${clientId}/insurance-authorization`;
export const FUNDERS = `${CLIENT}/funders`;
export const CLIENT_FUNDERS = (clientId: string) => `${CLIENTS}/${clientId}/funders`;
